<template>
    <Form :label-width="180">
        <Form-item label="起保日期：">
            {{info.effectiveDateStart}}
        </Form-item>
        <Form-item label="终保日期：">
            {{info.effectiveDateEnd}}
        </Form-item>
        <Form-item label="保额：">
            {{info.insuranceAmount}}元
        </Form-item>
        <Form-item label="保费：">
            {{info.premium}}元
        </Form-item>
    </Form>
</template>
<script>
export default {
    props:{
        info:{
            type:"Object",
            default:{}
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/common/securityPlan.vue